import type { NextPage } from 'next';
import Image from 'next/image';
import Link from 'next/link';
import _ from 'lodash';
import { getProvinces, Province } from '../../models/Province';

type Props = {
	province: Province;
	cities: any[];
};

const Brands: NextPage<Props> = ({ province, cities }) => {
	const createCard = (city: any) => {
		return (
			<Link
				href={'#'}
				key={`province-card-${province.code}-${city.code}`}
				className="shadow-lg rounded-2xl w-64 m-4 p-4 py-6 bg-white">
				<div className="flex flex-col items-center justify-center">
					<div className="w-24 h-24 rounded-full flex p-1">
						<Image
							src={`/images/provinces/${province.code}.png`}
							className="object-contain"
							alt={`Necesito empresa en ${city.name}, ${province.name}`}
							title={`Necesito empresa en ${city.name}, ${province.name}`}
							width={88}
							height={88}
							layout="fixed"
						/>
					</div>
					<h2 className="text-gray-800 text-xl font-medium mb-4 mt-4">
						Empresas en {city.name}, {province.name}
					</h2>
					{/* <h3 className="text-gray-400 text-center text-xs px-2">{station.shortDescription}</h3> */}
				</div>
			</Link>
		);
	};

	return (
		<div className="container">
			<div>
				<h1 className="text-3xl dark:text-gray-200">Todas las ciudades de {province.name}</h1>
				<h2 className="text-xl	dark:text-gray-200">
					A continuación te mostramos todas las ciudades donde encontrar empresas en {province.name}
				</h2>
			</div>
			<div className="flex flex-wrap justify-center">
				{cities.map((city: any) => {
					return createCard(city);
				})}
			</div>
		</div>
	);
};

export async function getStaticProps({ params }: { params: { provinceCode: string } }) {
	const { PrismaClient } = await import('@prisma/client');
	const prisma = new PrismaClient();

	const province = await prisma.provinces.findFirst({
		orderBy: [{ name: 'asc' }],
		where: { code: params.provinceCode }
	});

	const cities = await prisma.cities.findMany({
		orderBy: [{ name: 'asc' }],
		where: { province_code: parseInt(province?.provinceCode!).toString() }
	});

	console.log('traza', province?.provinceCode, cities.length);

	return {
		props: {
			cities: JSON.parse(JSON.stringify(cities)),
			province: JSON.parse(JSON.stringify(province)),
			title: `Empresas en ${province?.name}`
		}
	};
}

export async function getStaticPaths() {
	const { PrismaClient } = await import('@prisma/client');
	const prisma = new PrismaClient();

	const provinces = await prisma.provinces.findMany({ orderBy: [{ name: 'asc' }] });

	const paths = provinces.map((province) => {
		return { params: { provinceCode: province.code } };
	});

	return {
		paths: paths,
		fallback: false // can also be true or 'blocking'
	};
}

export default Brands;
